<template>
  
  <v-container my-5 style="max-width: 1000px">
    
    <router-link to="/create">
      <v-btn class="mb-5" color="primary" dark large block>Create a new form</v-btn>
    </router-link>

    <h1 class="display-3 text-xs-center">All your forms</h1>
    <v-timeline align-top dense>
      <v-timeline-item v-for="form in myForms" :key="form.formId" color="white" small>

        <v-layout pt-3 row>
          <v-flex xs12 md12>
            <h3>{{ form.data.title }}</h3>
            <p>Modified {{form.data.createdAt | moment("from")}}.</p>

            <v-layout class="justify-end">
              <router-link :to="'/report/' + form.formId">
                <v-btn flat small color="info">Result</v-btn>
              </router-link>
              <router-link :to="'/create/' + form.formId">
                <v-btn flat small color="warning">Edit</v-btn>
              </router-link>
              <router-link :to="'/view/' + form.formId">
                <v-btn flat small color="success">View</v-btn>
              </router-link>
              <!-- <v-btn flat small color="error" @click="removeForm(form.formId)">Delete</v-btn> -->
            </v-layout>
            <!-- <div class="caption">
              <p class="mb-0">Seen by 123 people</p>
              <p class="mt-0">Completed by 111 people</p>
            </div> -->
          </v-flex>
        </v-layout>
        <v-divider></v-divider>

      </v-timeline-item>
    </v-timeline>

    <v-dialog
      v-model="showSyncDialog"
      hide-overlay
      persistent
      width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
// @ is an alias to /src


export default {
  name: "numberbox",
  components: {},
  props: {},
  data: () => ({
    userObj: null,
    db: firebase.firestore(),
    myForms: [],
    showSyncDialog: true
  }),
  computed: {},
  created(){
    firebase.auth()
    .onAuthStateChanged((user)=> {
      if (user) {
        // User is signed in.
        this.userObj = user;

        this.db.collection('forms')
        .where("owners", "array-contains", this.userObj.uid)
        .get()
        .then((snapshot)=>{
          snapshot.forEach((doc)=>{
            const formData = {
              formId: doc.id,
              data: doc.data()
            }
            this.myForms.push(formData);
          });
          this.showSyncDialog = false;
        });

      } else {
        this.userObj = null;
        this.showSyncDialog = false;
        this.$router.push('/');
      }
    });


  },
  mounted() {
    
  },
  methods: {
    removeForm(formId) {
      this.db.collection('forms').doc(formId).delete();
    }
  }
};
</script>

<style scoped>

</style>